import type { Dispatch } from 'react';
import type { BaseEntity } from 'c-sdk';
import type { CoreThunk } from '../../Types/CoreThunk';
import type { SearchPayload } from '../../Types/Search';
import type { CustomListSearchGenerator } from '../../Types';

const hookUtilGetPaginatedList =
    <RootState, Entity extends BaseEntity>(
        thunk: (
            tag: string,
            searchPayload: SearchPayload<Entity>,
            asCursorPaginated?: boolean,
            customSearch?: CustomListSearchGenerator,
        ) => CoreThunk<RootState>,
    ) =>
    (
        tag: string,
        forceRefresh: boolean,
        searchPayload: SearchPayload<Entity>,
        dispatch: Dispatch<any>,
        asCursorPaginated = false,
        customSearch?: CustomListSearchGenerator,
        currentMetaPage?: number,
    ) => {
        // No in-flight check. A search asked for while another was running used to be discarded
        // silently — no request, no error — and on a list that refreshes itself that window is open
        // most of the time, so typing simply went missing. Overlapping requests are now allowed and
        // the reducers ignore any response that is no longer the newest for its tag.
        //
        // The page check stays: it stops a non-forced caller refetching a page it already has.
        if (currentMetaPage !== searchPayload.page || forceRefresh) {
            dispatch(thunk(tag, searchPayload, asCursorPaginated, customSearch));
        }
    };

export default hookUtilGetPaginatedList;
